// extracted by mini-css-extract-plugin
export default {"wrapper":"KN3gN","items":"_HN7g","label":"RBYeE"};